module.exports = __webpack_public_path__ + "static/img/about_one.986c8a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/about_one.png
// module id = yMMn
// module chunks = 1